module.exports = __webpack_public_path__ + "img/9788946052024.ee49da66.jpg";